import { render, staticRenderFns } from "./blog-post-card1.vue?vue&type=template&id=5d46cb4d&scoped=true"
import script from "./blog-post-card1.vue?vue&type=script&lang=js"
export * from "./blog-post-card1.vue?vue&type=script&lang=js"
import style0 from "./blog-post-card1.vue?vue&type=style&index=0&id=5d46cb4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46cb4d",
  null
  
)

export default component.exports